import img1 from 'assets/csdd_images/about__us__pic__.jpg';
import img2 from 'assets/csdd_images/aboutt_uss.jpg';
import img3 from 'assets/csdd_images/featured_article_final.jpg';
import img4 from 'assets/csdd_images/caro_special.jpg';
import img5 from 'assets/csdd_images/whowearepic.jpg';
import img6 from 'assets/csdd_images/article1_img.jpeg';

const data = [
  {
    title:
      'Procurement Chamber trains private contractors and suppliers on accurate tender procedures',
    images: [
      {
        img: img1,
        alt: 'Accurate tender procedures workshop',
      },
      {
        img: img2,
        alt: 'Accurate tender procedures workshop',
      },
      {
        img: img3,
        alt: 'Accurate tender procedures workshop',
      },
      {
        img: img4,
        alt: 'Accurate tender procedures workshop',
      },
      {
        img: img5,
        alt: 'Accurate tender procedures workshop',
      },
      {
        img: img6,
        alt: 'Accurate tender procedures workshop',
      },
    ],
  },
];

export default data;
